var exports = {
  "w": "xaf9ae18d--179e65--favorite-icon--redesign",
  "V": "xaf9ae18d--179e65--favorite-icon--active",
};

module.exports = exports;
